import { render, staticRenderFns } from "./Generic_Attributes.vue?vue&type=template&id=827aba9e&scoped=true&"
import script from "./Generic_Attributes.vue?vue&type=script&lang=js&"
export * from "./Generic_Attributes.vue?vue&type=script&lang=js&"
import style0 from "./Generic_Attributes.vue?vue&type=style&index=0&id=827aba9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827aba9e",
  null
  
)

export default component.exports